import React from "react";
import "./ConveyorChain.css";
import conimg from "./conveyor-chain.jpg";

const ConveyorChain = () => {
  return (
    <div className="main-conveyor">
      <div className="second-conveyor">
        <div className="conveyor1">
          <p>Conveyor Chain</p>
          <div>
            <p className="con2">Swajit Engineering Pvt.Ltd.>Conveyor Chain</p>
          </div>
        </div>
        <div className="conveyorchain">
          <h1 className="best">
            Best Automobile Conveyor Chain Manufacturers In India
          </h1>
          <p>
            We at Swajit are one of the leading Conveyor Chain Manufacturers in
            Aurangabad, Maharashtra, India. We strive to manufacture and supply
            the premium products such as conveyor chains and automobile conveyor
            chain to set advanced standards in the field of the machinery
            industry. Utilizing different technologies, we ensure that our
            offered range of conveyor chains have the best possible
            quality-price ratio. We are equipped with ourselves to deliver
            guaranteed, reasonable, and highest quality solutions for conveying
            applications all over the country.
          </p>
         
          <div className="con-chain">
          <img src={conimg} alt="img"></img>
          
          <div className="con-chain1">
            <div className="con-chain2">
            <p className="">
              All these conveyors are widely demanded in the market due to their
              rich and quality features such as:
            </p>
            <ul>
              <li> Abrasion and corrosion resistant</li>
              <li>Highly durable provide longer time service</li>
              <li>High load-bearing capacity</li>
              <li>Can withstand at any kind of environments</li>
              <li>Premium raw material used</li>
              <li>Reliable performance with a high efficiency</li>
              <li>Low maintenance requirements</li>
            </ul>
            </div>
            </div>
            </div>
         
          <div className="con-chain3">
            <p>
              Being the best automobile conveyor chain manufacturers in India at
              affordable prices mostly from Aurangabad Maharashtra, we provide
              custom-built conveyor chains with different specifications that
              satisfy the customer’s requirements.
            </p>
            <p>
              Our conveyor chains are mostly used in the industries such as
              automotive, machines & tools, food processing, packaging,
              mechanical engineering, chemical, pharmaceutical, cosmetics,
              plastics, wood, etc. We designed and fabricated conveyors that
              operate for a longer time with minimum supervision.
            </p>
            <p>Contact us on 9922941689 or Email marketing@swajit.com.</p>
            </div>
        </div>
      </div>
    </div>
  );
};

export default ConveyorChain;
